import React, { useEffect, useState } from "react";
import styles from "./dashboard.module.css";
import Chart from "react-apexcharts";
import { post } from "../../../components/api";

const CompanyDashboard = () => {
  const [data, setData] = useState({});
  const [lineGraph, setLineGraph] = useState([]);

  const fetchData = async () => {
    const response = await post("company/ltms_dashBoard", {});
    if (response.status == 200) {
      setData(response.data);
      const TripLineSeries = [
        {
          name: "Trips",
          data: response.data.tripPerMonth
            ? Array.from({ length: 12 }, (_, i) => {
                const monthData = response.data.tripPerMonth.find(
                  (item) => item._id.month === i + 1
                );
                return monthData ? monthData.tripCount : 0;
              })
            : [],
        },
        {
          name: "Loads",
          data: response.data.loadPerMonth
            ? Array.from({ length: 12 }, (_, i) => {
                const monthData = response.data.loadPerMonth.find(
                  (item) => item._id.month === i + 1
                );
                return monthData ? monthData.loadCount : 0;
              })
            : [],
        },
        {
          name: "amount",
          data: response.data.amountPaidPerMonth
            ? Array.from({ length: 12 }, (_, i) => {
                const monthData = response.data.amountPaidPerMonth.find(
                  (item) => item._id.month === i + 1
                );
                return monthData ? monthData.amountPaid : 0;
              })
            : [],
        },
        {
          name: "lastamount",
          data: response.data.lastYearAmountPaidPerMonth
            ? Array.from({ length: 12 }, (_, i) => {
                const monthData = response.data.lastYearAmountPaidPerMonth.find(
                  (item) => item._id.month === i + 1
                );
                return monthData ? monthData.amountPaid : 0;
              })
            : [],
        },
        {
          name: "amountPerTrip",
          data: response.data.previousPayment.map((data) => {
            return data.amountPaid;
          }),
        },
      ];
      setLineGraph(TripLineSeries);
    } else {
      setData({});
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const positiveColor = "rgba(18, 183, 106, 1)";
  // const negativeColor = "rgba(255, 39, 38, 1)";
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const options = {
    chart: {
      type: "bar",
      stacked: false,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
        dataLabels: {
          position: "top",
        },
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val > 0 ? val / 1000 + "k" : "";
      },
      offsetY: -15,
      style: {
        fontSize: "10px",
        fontWeight: "400",
        colors: ["rgba(0, 0, 0, 0.7)"],
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      title: {
        text: "Sales",
      },
    },
    colors: ["#3E6479", "#648394"],
    legend: {
      position: "bottom",
    },
  };

  const series = [
    {
      name: "Privious Year",
      data: lineGraph[3]?.data || [],
    },
    {
      name: "Current Year",
      data: lineGraph[2]?.data || [],
    },
  ];

  const trips = ["Trip A", "Trip B", "Trip C", "Trip D", "Trip E"];
  const payments = lineGraph[4]?.data || [];

  const pieOptions = {
    chart: {
      type: "pie",
    },

    labels: trips,
    colors: [
      "rgba(76, 120, 137, 0.8)",
      "rgba(76, 120, 137, 1)",
      "rgba(95, 133, 154, 1)",
      "rgba(62, 100, 121, 1)",
      "rgba(62, 100, 121, 1)",
      "rgba(76, 120, 137, 0.8)",
      "rgba(76, 120, 137, 1)",
      "rgba(95, 133, 154, 1)",
      "rgba(62, 100, 121, 1)",
      "rgba(62, 100, 121, 1)",
    ],
    legend: {
      position: "right",
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex] + " ₹";
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `₹ ${val}`,
      },
    },
  };

  const pieSeries = payments;

  const generateLineOption = (val) => {
    if (val >= 0) {
      return {
        chart: {
          type: "line",
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            top: 20,
            left: 0,
            blur: 15,
            opacity: 1,
            color: "rgba(18, 183, 106, 1)",
          },
        },
        colors: ["rgba(18, 183, 106, 1)"],
        stroke: {
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical", // vertical fade
            shadeIntensity: 0.4,
            gradientToColors: ["rgba(18, 183, 106, 0)"], // fade to transparent
            opacityFrom: 1,
            opacityTo: 0,
            stops: [0, 100],
          },
        },
        tooltip: {
          enabled: true,
          theme: "light",
          marker: {
            show: false, // optional to hide dot marker
          },
          x: {
            formatter: function (val) {
              return months[val - 1] || "";
            },
          },

          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    } else {
      return {
        chart: {
          type: "line",
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            top: 20,
            left: 0,
            blur: 15,
            opacity: 1,
            color: "rgba(255, 39, 38, 1)",
          },
        },
        colors: ["rgba(255, 39, 38, 1)"],
        stroke: {
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical", // vertical fade
            shadeIntensity: 0.4,
            gradientToColors: ["rgba(255, 39, 38, 1)"], // fade to transparent
            opacityFrom: 1,
            opacityTo: 0,
            stops: [0, 100],
          },
        },
        tooltip: {
          enabled: true,
          theme: "light",
          marker: {
            show: false, // optional to hide dot marker
          },
          x: {
            formatter: function (val) {
              return months[val - 1] || "";
            },
          },

          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    }
  };

  const TripLineOptions = {
    chart: {
      type: "line",
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: true,
        top: 20,
        left: 0,
        blur: 15,
        opacity: 1,
        color: "rgba(18, 183, 106, 1)",
      },
    },
    colors: ["rgba(18, 183, 106, 1)"],
    stroke: {
      curve: "smooth",
      width: 2,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical", // vertical fade
        shadeIntensity: 0.4,
        gradientToColors: ["rgba(18, 183, 106, 0)"], // fade to transparent
        opacityFrom: 1,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    tooltip: {
      enabled: true,
      theme: "light",
      marker: {
        show: false, // optional to hide dot marker
      },
      x: {
        formatter: function (val) {
          return months[val - 1] || "";
        },
      },

      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
  };

  // const TripLineSeries = [
  //   {
  //     data: [18, 15, 18, 16, 18, 18, 17, 10, 19],
  //   },
  // ];
  return (
    <div className={styles.dashboard}>
      <div className={styles.header}>
        <p>Dashboard</p>
      </div>
      <div>
        <div className="row">
          <div className={`col-md-3 mb-3`}>
            <div className={styles.card_body}>
              <div className={styles.card_body_Header}>
                <p>Total Trips</p>
                <p
                  className={
                    data?.monthCompare?.trips?.currentMonth -
                      data?.monthCompare?.trips?.lastMonth >=
                    0
                      ? styles.positiveColor
                      : styles.negativeColor
                  }
                >
                  {Math.abs(
                    data?.monthCompare?.trips?.currentMonth -
                      data?.monthCompare?.trips?.lastMonth
                  )}{" "}
                  {data?.monthCompare?.trips?.currentMonth -
                    data?.monthCompare?.trips?.lastMonth >=
                  0 ? (
                    <svg
                      width="13"
                      height="17"
                      viewBox="0 0 13 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.3763 6.24034C11.211 6.40594 10.9429 6.40594 10.7782 6.24034L6.67309 2.12704L6.67309 15.5761C6.67309 15.8102 6.48392 16 6.2501 16C6.01681 16 5.8271 15.8102 5.8271 15.5761L5.8271 2.12704L1.72204 6.24007C1.55731 6.40568 1.28921 6.40568 1.12395 6.24007C0.958683 6.07473 0.958683 5.80635 1.12395 5.64074L5.40756 1.34905C5.63208 1.12381 5.93126 1 6.2501 1C6.56921 1 6.86812 1.12407 7.09317 1.34932L11.3763 5.64101C11.5412 5.80661 11.5412 6.07499 11.3763 6.24034Z"
                        fill="#12B76A"
                        stroke="#12B76A"
                        strokeWidth="1.4025"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="13"
                      height="17"
                      viewBox="0 0 13 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.3763 10.7597C11.211 10.5941 10.9429 10.5941 10.7782 10.7597L6.67309 14.873L6.67309 1.42387C6.67309 1.18984 6.48392 1 6.2501 1C6.01681 1 5.8271 1.18984 5.8271 1.42387L5.8271 14.873L1.72204 10.7599C1.55731 10.5943 1.28921 10.5943 1.12395 10.7599C0.958683 10.9253 0.958683 11.1937 1.12395 11.3593L5.40756 15.6509C5.63208 15.8762 5.93126 16 6.2501 16C6.56921 16 6.86812 15.8759 7.09317 15.6507L11.3763 11.359C11.5412 11.1934 11.5412 10.925 11.3763 10.7597Z"
                        fill="#FF2726"
                        stroke="#FF0000"
                        strokeWidth="1.4025"
                      />
                    </svg>
                  )}
                </p>
              </div>
              <div>
                <Chart
                  options={generateLineOption(
                    data?.monthCompare?.trips?.currentMonth -
                      data?.monthCompare?.trips?.lastMonth
                  )}
                  series={[{ data: lineGraph[0]?.data }]}
                  type="line"
                  height={174}
                  className={styles.linechart}
                />
              </div>
            </div>
          </div>
          <div className={`col-md-3 mb-3`}>
            <div className={styles.card_body}>
              <div className={styles.card_body_Header}>
                <p>Total Loada</p>
                <p
                  className={
                    data?.monthCompare?.trips?.currentMonth -
                      data?.monthCompare?.trips?.lastMonth >=
                    0
                      ? styles.positiveColor
                      : styles.negativeColor
                  }
                >
                  {Math.abs(
                    data?.monthCompare?.loads?.currentMonth -
                      data?.monthCompare?.loads?.lastMonth
                  )}{" "}
                  {data?.monthCompare?.trips?.currentMonth -
                    data?.monthCompare?.trips?.lastMonth >=
                  0 ? (
                    <svg
                      width="13"
                      height="17"
                      viewBox="0 0 13 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.3763 6.24034C11.211 6.40594 10.9429 6.40594 10.7782 6.24034L6.67309 2.12704L6.67309 15.5761C6.67309 15.8102 6.48392 16 6.2501 16C6.01681 16 5.8271 15.8102 5.8271 15.5761L5.8271 2.12704L1.72204 6.24007C1.55731 6.40568 1.28921 6.40568 1.12395 6.24007C0.958683 6.07473 0.958683 5.80635 1.12395 5.64074L5.40756 1.34905C5.63208 1.12381 5.93126 1 6.2501 1C6.56921 1 6.86812 1.12407 7.09317 1.34932L11.3763 5.64101C11.5412 5.80661 11.5412 6.07499 11.3763 6.24034Z"
                        fill="#12B76A"
                        stroke="#12B76A"
                        strokeWidth="1.4025"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="13"
                      height="17"
                      viewBox="0 0 13 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.3763 10.7597C11.211 10.5941 10.9429 10.5941 10.7782 10.7597L6.67309 14.873L6.67309 1.42387C6.67309 1.18984 6.48392 1 6.2501 1C6.01681 1 5.8271 1.18984 5.8271 1.42387L5.8271 14.873L1.72204 10.7599C1.55731 10.5943 1.28921 10.5943 1.12395 10.7599C0.958683 10.9253 0.958683 11.1937 1.12395 11.3593L5.40756 15.6509C5.63208 15.8762 5.93126 16 6.2501 16C6.56921 16 6.86812 15.8759 7.09317 15.6507L11.3763 11.359C11.5412 11.1934 11.5412 10.925 11.3763 10.7597Z"
                        fill="#FF2726"
                        stroke="#FF0000"
                        strokeWidth="1.4025"
                      />
                    </svg>
                  )}
                </p>
              </div>
              <div>
                <Chart
                  options={generateLineOption(
                    data?.monthCompare?.loads?.currentMonth -
                      data?.monthCompare?.loads?.lastMonth
                  )}
                  series={[{ data: lineGraph[1]?.data }]}
                  type="line"
                  height={174}
                />
              </div>
            </div>
          </div>
          <div className={`col-md-3 mb-3`}>
            <div className={styles.card_body}>
              <div className={styles.card_body_Header}>
                <p>Total Trips</p>
                <p className={styles.card_body_Header_amount}>
                  INR{" "}
                  {data?.amountPaidPerMonth
                    ? data?.amountPaidPerMonth.reduce((total, num) => {
                        return total + Math.round(num?.amountPaid || 0);
                      }, 0)
                    : 0}
                </p>
              </div>
              <div>
                <Chart
                  options={TripLineOptions}
                  series={[{ data: lineGraph[2]?.data }]}
                  type="line"
                  height={174}
                />
              </div>
            </div>
          </div>

          <div className={`col-md-3 mb-3`}>
            <div className={styles.card_body}>
              <div className={styles.card_body_half}>
                <div className={styles.card_body_Header}>
                  <p className={styles.mainText}>Active trips</p>
                  <p className={styles.MainNumber}>
                    {data.currentMonthActiveTrips}
                  </p>
                  <p className={styles.secondaryNumber}>
                    <svg
                      width="7"
                      height="9"
                      viewBox="0 0 7 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.94107 3.49536C5.86237 3.57422 5.73471 3.57422 5.65627 3.49536L3.70147 1.53665L3.70147 7.94098C3.70147 8.05242 3.61139 8.14282 3.50005 8.14282C3.38896 8.14282 3.29862 8.05242 3.29862 7.94098L3.29862 1.53665L1.34383 3.49524C1.26538 3.5741 1.13772 3.5741 1.05902 3.49524C0.980324 3.4165 0.980324 3.2887 1.05902 3.20984L3.09884 1.16618C3.20575 1.05892 3.34822 0.999964 3.50005 0.999964C3.652 0.999964 3.79434 1.05905 3.90151 1.16631L5.94107 3.20997C6.01964 3.28883 6.01964 3.41663 5.94107 3.49536Z"
                        stroke="#12B76A"
                        strokeWidth="0.476191"
                      />
                    </svg>
                    40%
                    <span className={styles.secondaryText}>vs last month</span>
                  </p>
                </div>
                <div></div>
              </div>
              <div className={styles.card_body_half2}>
                <div className={styles.card_body_Header}>
                  <p className={styles.mainText}>Completed trips</p>
                  <p className={styles.MainNumber}>
                    {data?.currentMonthCompletedTrips}
                  </p>
                  <p className={styles.secondaryNumber}>
                    <svg
                      width="7"
                      height="9"
                      viewBox="0 0 7 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.94107 3.49536C5.86237 3.57422 5.73471 3.57422 5.65627 3.49536L3.70147 1.53665L3.70147 7.94098C3.70147 8.05242 3.61139 8.14282 3.50005 8.14282C3.38896 8.14282 3.29862 8.05242 3.29862 7.94098L3.29862 1.53665L1.34383 3.49524C1.26538 3.5741 1.13772 3.5741 1.05902 3.49524C0.980324 3.4165 0.980324 3.2887 1.05902 3.20984L3.09884 1.16618C3.20575 1.05892 3.34822 0.999964 3.50005 0.999964C3.652 0.999964 3.79434 1.05905 3.90151 1.16631L5.94107 3.20997C6.01964 3.28883 6.01964 3.41663 5.94107 3.49536Z"
                        stroke="#12B76A"
                        strokeWidth="0.476191"
                      />
                    </svg>
                    40%
                    <span className={styles.secondaryText}>vs last month</span>
                  </p>
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div className={`col-md-6 mb-3`}>
            <div className={styles.card_body}>
              <div className={styles.big_card_body_Header}>
                <p>Total Paid Amount Monthly</p>
              </div>
              <div>
                <Chart
                  options={options}
                  series={series}
                  type="bar"
                  height={350}
                />
              </div>
            </div>
          </div>
          <div className={`col-md-6 mb-3`}>
            <div className={styles.card_body}>
              <div className={styles.big_card_body_Header}>
                <p>Total Paid Amount Monthly</p>
              </div>
              <div>
                <Chart
                  options={pieOptions}
                  series={pieSeries}
                  type="pie"
                  height={350}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDashboard;
